export default {"src":"/_next/static/media/eggs.82be415a.svg","height":16,"width":21,"blurWidth":0,"blurHeight":0};